import React from 'react';
import { motion } from 'framer-motion';
interface MarqueeProps {
  children: React.ReactNode;
  /** Duración de una vuelta completa, en segundos. */
  speed?: number;
  reverse?: boolean;
  className?: string;
}
export function Marquee({
  children,
  speed = 38,
  reverse = false,
  className
}: MarqueeProps) {
  return <div className={`relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)] ${className ?? ''}`} data-id="element-184" data-mp="17p9l4vo9wfit">
      <motion.div className="flex w-max gap-4" animate={{
      x: reverse ? ['-50%', '0%'] : ['0%', '-50%']
    }} transition={{
      duration: speed,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-185" data-mp="1hm4el05ovpq8">
        <div className="flex shrink-0 gap-4" data-id="element-186" data-mp="1rcqs8otui66a">{children}</div>
        <div className="flex shrink-0 gap-4" aria-hidden="true" data-id="element-187" data-mp="1rea6yazus95y">
          {children}
        </div>
      </motion.div>
    </div>;
}